import Icon from './Icon';

const Sort = ({ className }) => (
  <Icon name="sort" className={className} viewBox="0 0 18 12">
    <path d="M0,12 L6,12 L6,10 L0,10 L0,12 L0,12 Z M0,0 L0,2 L18,2 L18,0 L0,0 L0,0 Z M0,7 L12,7 L12,5 L0,5 L0,7 L0,7 Z" />
  </Icon>
);

// https://material.io/icons/#ic_settings (adapted)
export default Sort;
